import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyNextUp: BaseKeyFunction = () => ["nextup"];
